type CollectionRouteTarget =
  | { name: 'workspace-detail'; params: { workspaceId: string } }
  | { name: 'workspaces' }

type LastCollectionContext = { type: 'overview' } | { type: 'detail'; workspaceId: string }

let lastCollectionContext: LastCollectionContext | null = null

export const rememberCollectionsOverviewContext = () => {
  lastCollectionContext = { type: 'overview' }
}

export const rememberLastCollectionContext = (workspaceId: string | null | undefined) => {
  const trimmedWorkspaceId = workspaceId?.trim()
  if (!trimmedWorkspaceId) return

  lastCollectionContext = { type: 'detail', workspaceId: trimmedWorkspaceId }
}

export const getLastCollectionRouteTarget = (): CollectionRouteTarget => {
  if (!lastCollectionContext || lastCollectionContext.type === 'overview') {
    return { name: 'workspaces' }
  }

  return {
    name: 'workspace-detail',
    params: { workspaceId: lastCollectionContext.workspaceId },
  }
}

export const hasLastCollectionContext = () => lastCollectionContext !== null

export const resetLastCollectionContextForTests = () => {
  lastCollectionContext = null
}
